export default __webpack_public_path__ + "static/media/fantastic_bg_2.74b84e0b.png";